import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  PaperClipOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Tooltip,
  Upload,
} from 'antd'
import React, { useCallback } from 'react'
import { useRef } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import RichEditor from '../../../components/RichEditor/RichEditor'
import SpinnerInlineComponent from '../../../components/SpinnerInlineComponent'
import commonStore from '../../../stores/commonStore'
import validator from '../../../validator'
import {
  UploadFileListItem,
  UploadFileListWrapper,
} from '../../ConnectedDocumentOutgoingDocCreatePage/ConnectedDocumentOutgoingDocCreatePageStyled'
import {
  FileListItem,
  FileListWrapper,
} from '../../RiskDetailPage/RiskDetailPageStyled'
import fileStore from '../../../stores/fileStore'

const { TextArea } = Input

const RiskAriseUpsertModal = ({
  isVisible,
  handleCancelCreateModal,
  type,
  riskAriseStore,
  loadRiskAriseList,
  handleCancelEditModal,
  risk,
  setEditRisk,
  onFinish,
}) => {
  const { Option } = Select
  const { createRiskArise, updateRiskArise } = riskAriseStore
  const [form] = Form.useForm()
  const CAUSE_REF = useRef()
  const [isRenderRichText, setIsRenderRichText] = useState(false)
  const [riskAriseTypes, setRiskAriseTypes] = useState()
  const [fileList, setFileList] = useState([])
  const [fileUploadedList, setFileUploadedList] = useState([])

  const loadTypes = async () => {
    try {
      const { data } = await riskAriseStore.getRiskAriseTypes()
      setRiskAriseTypes(data)
    } catch (error) {
      console.log('🚀 error:', error)
      message.error('Đã có lỗi xảy ra')
    }
  }

  useEffect(() => {
    loadTypes()
  }, [])

  useEffect(() => {
    if (!risk) {
      return
    }
    form.setFieldsValue({
      assigned_work: risk.assigned_work,
      time_arises: risk.time_arises,
      identification_risk: risk.identification_risk,
      reason: risk.reason,
      type: risk.type,
    })
    setFileUploadedList(risk?.attachments)
  }, [risk])

  const [buttonBlock, setButtonBlock] = useState(false)

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => {
        setIsRenderRichText(true)
      }, 400)
    } else {
      setIsRenderRichText(false)
    }
  }, [isVisible])

  const handleChangeFile = useCallback(
    info => {
      if (risk) {
        const newFileList = info.fileList
        const filteredFileList = newFileList.filter(
          (elem, index, fileArray) =>
            fileArray.findIndex(file => file.name === elem.name) === index
        )

        const finalFileList = filteredFileList.filter(file => {
          const isDuplicate = fileUploadedList.some(
            uploadedFile => uploadedFile.file_name === file.name
          )
          if (isDuplicate) {
            message.warning(`File "${file.name}" đã tồn tại`)
            return false
          }
          return true
        })

        setFileList(finalFileList)
      } else {
        const filteredFileList = info.fileList.filter(
          (elem, index, fileArray) =>
            fileArray.findIndex(file => file.name === elem.name) === index
        )
        setFileList(filteredFileList)
      }
    },
    [fileUploadedList]
  )

  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }

  const handleUpsertRisk = async value => {
    setButtonBlock(true)
    const uploadFileList = fileList.map(file => file.originFileObj)
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    const response = await Promise.all(batchUploadArr)
    const fileIds = risk
      ? response
          .map(r => r.data.file_id)
          .concat(fileUploadedList.map(f => f.file_id))
      : response.map(r => r.data.file_id)
    const submitData = {
      assigned_work: value.assigned_work.trim(),
      time_arises: value.time_arises.trim(),
      identification_risk: value.identification_risk.trim(),
      // @ts-ignore
      reason: CAUSE_REF.current.editor.getData(),
      type: value.type,
      attachments: fileIds,
    }
    try {
      risk
        ? await updateRiskArise(risk.id, submitData)
        : await createRiskArise(submitData)
      risk
        ? message.success('Cập nhật thành công')
        : message.success('Tạo mới thành công')
      handleCancelCreateModal()
      setEditRisk(null)
      onFinish()
    } catch {
      message.error('Đã có lỗi xảy ra')
    }
  }

  return (
    <Modal
      visible={isVisible}
      footer={null}
      destroyOnClose={true}
      afterClose={() => {
        setButtonBlock(false)
        setIsRenderRichText(false)
      }}
      width={600}
      onCancel={() => {
        ;(risk ? handleCancelEditModal : handleCancelCreateModal)()
        setFileList([])
        setFileUploadedList(risk?.attachments)
      }}
      title={
        <>
          {/* @ts-ignore */}
          <ExclamationCircleOutlined
            style={{
              color: commonStore.appTheme.solidColor,
              marginRight: 10,
            }}
          />
          {risk
            ? 'Cập nhật rủi ro nhận diện phát sinh'
            : 'Tạo mới rủi ro nhận diện phát sinh'}
        </>
      }>
      <Form
        layout={'vertical'}
        onFinish={handleUpsertRisk}
        preserve={false}
        form={form}>
        <Form.Item
          label={'Loại'}
          name={'type'}
          rules={[{ required: true, message: 'Vui lòng chọn !' }]}>
          <Select
            style={{ minWidth: '250px' }}
            placeholder={'Chọn loại'}
            allowClear
            disabled={risk ? true : false}>
            {riskAriseTypes?.length > 0 &&
              riskAriseTypes.map(type => (
                <Option key={type.code} value={type.code}>
                  {type.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item
          label={'Công việc được giao'}
          name={'assigned_work'}
          rules={[
            { required: true, message: 'Vui lòng nhập !' },
            { validator: validator.validateInputString },
          ]}>
          <TextArea rows={3} placeholder={'Nhập công việc được giao'} />
        </Form.Item>
        <Form.Item
          label={'Rủi ro nhận diện'}
          name={'identification_risk'}
          rules={[
            { required: true, message: 'Vui lòng nhập !' },
            { validator: validator.validateInputString },
          ]}>
          <TextArea rows={3} placeholder={'Nhập rủi ro nhận diện'} />
        </Form.Item>
        <Form.Item
          label={'Thời gian phát sinh'}
          name={'time_arises'}
          rules={[
            { required: true, message: 'Vui lòng nhập !' },
            { validator: validator.validateInputString },
          ]}>
          <Input placeholder={'Nhập thời gian phát sinh'} />
        </Form.Item>
        <Form.Item label={'Tài liệu đính kèm:'} name={'id_file_dinh_kem'}>
          <Upload
            valuePropName={'fileList'}
            fileList={fileList}
            multiple={true}
            onChange={handleChangeFile}
            beforeUpload={() => false}
            showUploadList={false}>
            <Button htmlType={'button'}>
              <UploadOutlined />
              Chọn tài liệu đính kèm
            </Button>
          </Upload>
        </Form.Item>
        {fileList.length !== 0 && (
          <UploadFileListWrapper>
            {fileList.map(file => (
              <UploadFileListItem key={file.uid}>
                <FileTextOutlined />
                <span>{file.name}</span>
                <Tooltip title={'Xoá tập tin'}>
                  <DeleteOutlined
                    onClick={() => handleRemoveFileFromUploadList(file.uid)}
                  />
                </Tooltip>
              </UploadFileListItem>
            ))}
          </UploadFileListWrapper>
        )}
        {fileUploadedList && fileUploadedList.length !== 0 && (
          <FileListWrapper>
            {fileUploadedList.map(file => (
              <FileListItem key={file.file_id}>
                <PaperClipOutlined />
                <span>{file.file_name}</span>
                <Tooltip title={'Xoá tập tin'}>
                  <DeleteOutlined
                    onClick={() =>
                      setFileUploadedList(
                        fileUploadedList.filter(
                          el => el.file_id !== file.file_id
                        )
                      )
                    }
                  />
                </Tooltip>
              </FileListItem>
            ))}
          </FileListWrapper>
        )}
        <Form.Item label={'Nguyên nhân'} name={'reason'}>
          {!isRenderRichText && (
            <div style={{ height: 312, position: 'relative' }}>
              <SpinnerInlineComponent
                sizeSpin={'small'}
                tip="Đang tải dữ liệu..."
                isLoading={!isRenderRichText}
                backGround={'#ffffffc7'}
              />
            </div>
          )}
          {isRenderRichText && (
            <RichEditor
              EDITOR_REF={CAUSE_REF}
              placeholder={'Nhập nội dung...'}
              editorContent={risk?.reason}
            />
          )}
        </Form.Item>
        <Row justify={'end'}>
          <Space>
            <Button
              onClick={risk ? handleCancelEditModal : handleCancelCreateModal}>
              Hủy
            </Button>
            <Button
              disabled={buttonBlock ? true : false}
              type={'primary'}
              htmlType={'submit'}>
              {risk ? 'Cập nhật' : 'Tạo mới'}
            </Button>
          </Space>
        </Row>
      </Form>
    </Modal>
  )
}

export default RiskAriseUpsertModal
